import type { Right } from '@gozoki/tools'
import { Button, Tooltip, type ButtonProps } from '@mui/material'
import { usePermissionGuard, type PermissionRequirement } from '~/utils/rbac'

export type AuthorizedButtonProps = ButtonProps & {
  /**
   * Droit(s) requis : un tuple, un tableau de tuples (ET), ou `{ any: [...] }` (OU) pour un bouton
   * qui reste actionnable avec l'un OU l'autre droit — p. ex. « Modifier » / « Voir ».
   */
  permission: PermissionRequirement
  /**
   * Droits v1 exigés tant que le flag `permission-v2` est OFF (où les tuples v2 passent tous).
   * À renseigner sur tout bouton qui était gardé par `useRights(...)` avant la migration.
   */
  legacyRights?: Right[]
}

export const AuthorizedButton = ({
  permission,
  legacyRights,
  ...buttonProps
}: AuthorizedButtonProps) => {
  const guard = usePermissionGuard(permission, legacyRights)

  if (guard.authorized) return <Button {...buttonProps} />

  // Un Button MUI désactivé n'émet aucun évènement pointeur : le `<span>` porte le tooltip.
  return (
    <Tooltip title={guard.tooltip}>
      <span>
        <Button {...buttonProps} disabled />
      </span>
    </Tooltip>
  )
}
